/** Issuer block on TAX INVOICE PDF — keep in sync with backend pdf_generator.py */
export const UPTRADER_INVOICE_ISSUER = {
  companyName: 'UPTRADER SOFTWARE DESIGN LLC',
  address: '574-0, AL ABBAS BLDG.2, Mankhool, Dubai, UAE',
  trn: '104026940700003',
  registrationNo: '1710356',
  iban: 'AE380340003708449851002',
  bankName: 'EMIRATES ISLAMIC BANK P.J.S.C.',
  bankCountry: 'UNITED ARAB EMIRATES',
  bankAddress: 'AL YOUSUF TOWER DEIRA, DUBAI',
  bicSwift: 'MEBLAEADXXX',
  email: 'mail@uptrader.io',
} as const;
